import type { State } from './types.tsx';

export const getBaseUrl = (state: State) => state.appProps.baseUrl;
export const getProjectKey = (state: State) => state.appProps.projectKey;
export const getProjectId = (state: State) => state.appProps.projectId;
export const getProjectDefaultAssignee = (state: State) => state.appProps.projectDefaultAssignee;
export const getProjectLeadName = (state: State) =>
	state.appProps.projectLead ? state.appProps.projectLead.displayName : '';

export const getOnClose = (state: State) => state.appProps.onClose;
export const getOnComplete = (state: State) => state.appProps.onComplete;
export const getOnError = (state: State) => state.appProps.onError;

export const getComponent = (state: State) => state.component;
export const getName = (state: State) => state.component.name;
export const getDescription = (state: State) => state.component.description;
export const getDefaultAssignee = (state: State) => state.component.defaultAssignee;
export const getLead = (state: State) => state.component.lead;

export const getNameErrorMessage = (state: State) => state.errors.name;

// getLeadErrorMessage appears unused - can we remove?
export const getLeadErrorMessage = (state: State) => state.errors.componentLead;

export const isSaving = (state: State) => state.isSaving;
export const canSubmit = (state: State) => !isSaving(state) && !!getName(state).trim();
